import { render, staticRenderFns } from "./SelectionBox.vue?vue&type=template&id=6b62f0c2&scoped=true"
import script from "./SelectionBox.vue?vue&type=script&lang=ts"
export * from "./SelectionBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectionBox.vue?vue&type=style&index=0&id=6b62f0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62f0c2",
  null
  
)

export default component.exports